import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  RsuAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_RsuAwardListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetRsuAwardsParticipantsList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType & {
    awardTypeFilter?: string;
    fromApproveDate?: string;
    toApproveDate?: string;
    fromPublishDate?: string;
    toPublishDate?: string;
  }
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_RsuAwardListDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: rsuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    fromApproveDate,
    toApproveDate,
    fromPublishDate,
    toPublishDate,
    awardTypeFilter,
    _force,
  } = tableInfo;
  const rsuStatus = 0;

  const RsuAwardsParticipantApprovalData = useQuery(
    [
      'getRsuAwardsParticipantApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      rsuStatus,
      rsuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      awardTypeFilter,
      fromApproveDate,
      toApproveDate,
      fromPublishDate,
      toPublishDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        RsuAwardApprovalService.getApiAwardApiAppRSUAwardApprovalRSUAwardList(
          approvalStatusId ?? [0],
          employeeStatusId ?? [0],
          rsuStatus,
          rsuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          fromApproveDate,
          toApproveDate,
          fromPublishDate,
          toPublishDate,
          awardTypeFilter,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return RsuAwardsParticipantApprovalData;
};

export default useGetRsuAwardsParticipantsList;
